// Preserves the TM-5692 behaviour: without the PROPOSALS module, Settings opens on Team members.
function resolveSettingsUrl(user) {
  const hasProposals = Array.isArray(user.moduleAccess) && user.moduleAccess.includes('PROPOSALS');

  return hasProposals ? '/venue-cabinet/company-details' : '/venue-cabinet/venues-managers';
}

export function enhanceLinksWithData({ links, user }) {
  return links.map(link => {
    switch (link.name) {
      case 'enquiries': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.unreadEnquiriesCount,
          },
        };
      }
      case 'userEnquiries': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.unreadEnquiries,
          },
        };
      }
      case 'favorites': {
        return {
          ...link,
          options: {
            ...link.options,
            value: user.wishList.length,
          },
        };
      }
      case 'settings': {
        return { ...link, options: { ...link.options }, url: resolveSettingsUrl(user) };
      }
      default:
        return link;
    }
  });
}
